/*
  bare cart upsell: one-click Add buttons in the slide-out cart (snippets/bare-cart-upsell.liquid).
  Adds the product as a one-time item, then re-renders the drawer from the same response.
*/
document.addEventListener('click', async (e) => {
  const button = e.target.closest('[data-upsell-add]');
  if (!button) return;
  const drawer = button.closest('cart-drawer');
  if (!drawer) return;

  button.disabled = true;
  button.setAttribute('aria-busy', 'true');
  try {
    const res = await fetch((window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        items: [{ id: parseInt(button.dataset.upsellAdd, 10), quantity: 1 }],
        sections: drawer.getSectionsToRender().map((s) => s.id),
      }),
    });
    const data = await res.json();
    if (!res.ok) throw new Error(data.description || data.message);
    drawer.renderContents({ id: data.items[0].id, sections: data.sections });
  } catch (err) {
    button.disabled = false;
    button.removeAttribute('aria-busy');
    button.textContent = 'Try again';
  }
});
